import { Box } from "@/components/ui/box";
import { SafeAreaView } from "@/components/ui/safe-area-view";
import { VStack } from "@/components/ui/vstack";
import Logo from "@/screens/menu/logo/logo";
import { Slot } from "expo-router";
import { useColorScheme } from "@/components/useColorScheme";
import { ColorSchemeName } from "react-native";
import { Heading } from "@/components/ui/heading";

export default function InvitationLayout() {
  const colorScheme: ColorSchemeName = useColorScheme();

  return (
    <SafeAreaView className="w-full h-full bg-background-0">
      <VStack className="w-full h-full items-center p-4">
        <Box className="w-36 h-11 self-start md:self-auto">
          <Logo
            color={colorScheme === "dark" ? "white" : "black"}
            fill={colorScheme === "dark" ? "white" : "black"}
            width="100%"
            height="100%"
          />
        </Box>
        <VStack className="w-full h-full max-w-screen-sm justify-center -mt-11">
          <VStack className="gap-4">
            <Heading className="md:text-center" size="3xl">
              You are being redirected...
            </Heading>
            <Slot />
          </VStack>
        </VStack>
      </VStack>
      {/* <Center>

        <VStack className="justify-center h-screen h-screen-safe gap-4 -mt-11">
          <VStack className="gap-4">
            <Heading className="md:text-center" size="3xl">
              You are being redirected...
            </Heading>
            <Slot />
          </VStack>
        </VStack>
      </Center> */}
    </SafeAreaView>
  );
}
